import {initElements} from "../define/shared"

export default function initCf7Form() {
    initElements(".wpcf7", cf7 => {
        const fields = cf7.querySelectorAll('.wa-field')

        fields.forEach(field => {
            const input = field.querySelector('input')

            input.addEventListener('focus', () => {
                field.classList.add('is--focused')
            })

            input.addEventListener('blur', () => {
                field.classList.remove('is--focused')

                if (input.value) {
                    field.classList.add('is--filled')
                } else {
                    field.classList.remove('is--filled')
                }
            })
        })
    })
}
